export enum SubscriptionChannels {
  HIGH_PRIORITY = 'HIGH_PRIORITY',
  JOB_RELATED = 'JOB_RELATED',
  OTHER = 'OTHER',
  WAR_ROOM = 'WAR_ROOM',

  ALL = 'ALL', // There is no channel subscription only used for ui purposes
}
